module.exports = __webpack_public_path__ + "static/media/mayakoba.1227c0f4.png";